import React from 'react'
import LabelParameters from '../LabelParameters'
import styles from '../CreateParameterPopup.module.css'
import { useTranslation } from 'react-i18next';
import CustomDropdown from '../../CustomDropdown/CustomDropdown';
const UnitOfMeasurement = ({parameterData, handleChange,editingInput,setEditingInput}) => {
  const [t] = useTranslation("Contacts");

  return (
    <div>
        
      <LabelParameters value={parameterData.UnitOfMeasurement} text={'unitOfMeasurement'} editingInput={editingInput} setEditingInput={setEditingInput} >
      <div className={styles.unitMeasure}>
            <CustomDropdown
              editable={true}
              editing={true}
              options={[
                t("length"),
                t("weight"),
                t("volumen"),
                t("time"),
                t("speed"),
              ]}
              customStyles={styles.noPadding}
              selectedOption={parameterData?.physicalQuantities}
              setSelectedOption={(option) =>
                handleChange({ name: "physicalQuantities", newValue: option })
              }
              father={'automate'}
            />
            <input
          type="text"
          value={parameterData?.UnitOfMeasurement}
          name={'UnitOfMeasurement'}
          onChange={handleChange}
          placeholder='00.00'
        />
            <CustomDropdown
              editable={true}
              editing={true}
              options={[
                t("length"),
                t("weight"),
                t("volumen"),
                t("time"),
                t("speed"),
              ]}
              customStyles={styles.noPadding}
              selectedOption={parameterData?.unitMeasure}
              setSelectedOption={(option) =>
                handleChange({ name: "unitMeasure", newValue: option })
              } 
              father={'automate'}
            />
          </div>
</LabelParameters>
    </div>
  )
}

export default UnitOfMeasurement